import PropTypes from "prop-types";

function Description({ words }) {
  return (
    <div>
      <div>Avec cette activité, tu vas valider l&apos;orthographe de {words.length} mots.</div>
    </div>
  );
}

Description.propTypes = {
  words: PropTypes.arrayOf(PropTypes.string),
};

export default Description;
